// extracted by mini-css-extract-plugin
export default {"container":"TopPanel_container__W0HZ0"};